import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {fetchedPage, loadPage} from "../../actions/page";
import Title from "../elements/Title";
import HeroImage from "../elements/HeroImage";
import BlockLoop from "../elements/BlockLoop";
import Loader from "react-loader";
import Resources from "../elements/Resources";
import MissingPage from "../elements/MissingPage"
import TopBar from "../layout/TopBar";
import TopNavigation from "../navigation/TopNavigation";
import Footer from "../layout/Footer";
import SideBar from "../navigation/SideBar";

class NewsPage extends React.Component {

    constructor(props) {

        super(props)
        this.state = {
            missing: false
        }

    }
    componentWillUnmount() {
        this.props.loadPage()
    }

    componentDidMount() {
        this.props.fetchedPage('/api' + this.props.location.pathname).then(res => this.setState({missing: false})).catch(
          res => this.setState({missing: true})
        );
    }

    componentDidUpdate(prevProps) {

        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.props.fetchedPage('/api' + this.props.location.pathname).then(res => this.setState({missing: false})).catch(
              res => this.setState({missing: true})
            );
        }
    }

    isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    render() {

        if (this.state.missing === true) {
            return <MissingPage url={'/assets/general/Placeholder.png'} title={'PlaceHolder'}/>;
        }

        const {page, modal, navigation, loaded} = this.props;
        let quotation;
        if (this.isEmpty(page.resources)) {
            quotation = <div className="row">
                <div className={"col-md-12"}>
                    <BlockLoop/>
                </div>
            </div>;
        } else {
            quotation = <div className="container">
                <div className={"row"}>
                    <div className={"col-md-8"}>
                        <BlockLoop/>
                    </div>
                    <div className={"col-md-4"}>
                        <Resources resources={page.resources}/>
                    </div>
                </div>
            </div>;
        }

        return (
          <Loader loaded={loaded}>
          <div className={"transition-item"}>
              <div className={modal.activeClass === false ? "rob" : "rob rob__blur"}>
                  <TopBar/>
                  <TopNavigation/>
                  <SideBar navigation={navigation}/>
                  <HeroImage {...page.heroImage}  />
                  <Title introTitle={page.title}/>
                  {quotation}
                  <Footer/>
              </div>
          </div>
          </Loader>
        )
    };

}

NewsPage.propTypes = {
    fetchedPage: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {

        page: state.page,
        modal: state.modal,
        navigation: state.navigation,
        loaded: state.loaded.loaded
    };
}

export default connect(mapStateToProps, {fetchedPage, loadPage})(NewsPage);




// WEBPACK FOOTER //
// ./src/components/pages/NewsPage.js